import { useEffect, useState } from 'react';
import { fetchRenewals } from '../services/api';

function alertBadge(days: number | null) {
  if (days == null) return <span className="badge gray">–</span>;
  if (days <= 0) return <span className="badge red">Expiré</span>;
  if (days <= 30) return <span className="badge red">30 jours</span>;
  if (days <= 90) return <span className="badge orange">90 jours</span>;
  return <span className="badge blue">À venir</span>;
}

export default function RenewalsPage() {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRenewals()
      .then(setData)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) return <div className="error-msg">{error}</div>;
  if (loading) return <div className="loading">Chargement...</div>;

  const summary = data?.summary || data?.kpis || {};
  const items = data?.items || data?.upcoming || (Array.isArray(data) ? data : []);

  return (
    <div className="card">
      <h3>Calendrier des renouvellements</h3>

      <div className="grid4" style={{ marginTop: 18 }}>
        <div className="kpi"><small>Dans 90 jours</small><strong>{summary.within_90d ?? items.filter((r: any) => r.days_remaining != null && r.days_remaining <= 90 && r.days_remaining > 0).length}</strong></div>
        <div className="kpi"><small>Dans 30 jours</small><strong>{summary.within_30d ?? items.filter((r: any) => r.days_remaining != null && r.days_remaining <= 30 && r.days_remaining > 0).length}</strong></div>
        <div className="kpi"><small>Expirées</small><strong>{summary.expired ?? items.filter((r: any) => r.days_remaining != null && r.days_remaining <= 0).length}</strong></div>
        <div className="kpi"><small>Montant à prévoir</small><strong>{summary.total_amount_usd ?? '–'} USD</strong></div>
      </div>

      <div className="table-wrap" style={{ marginTop: 18 }}>
        <table>
          <thead>
            <tr><th>Date</th><th>Établissement</th><th>Catégorie</th><th>Durée</th><th>Montant</th><th>Alerte</th><th>Action</th></tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--muted)' }}>Aucun renouvellement prévu</td></tr>}
            {items.map((r: any, i: number) => (
              <tr key={i}>
                <td>{r.renewal_date || r.date || '–'}</td>
                <td>{r.establishment_name || r.name || '–'}</td>
                <td>{r.category || '–'}</td>
                <td>{r.duration || '12 mois'}</td>
                <td>{r.amount_usd ?? '–'} USD</td>
                <td>{alertBadge(r.days_remaining)}</td>
                <td><button className="btn primary">Préparer</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
